// extracted by mini-css-extract-plugin
export default {"login":"qfUKeN","logOutText":"GH4CJN"};